const riskTypes = Object.freeze({
  0: 'Bacen',
  1: 'Sicoob'
})

export default riskTypes



// WEBPACK FOOTER //
// ./src/enums/enumRiskTypes.js